import { HttpService } from "../../modules/shared/services/http.service";
import { Contract, ContractCreateDto, MilestonePaymentLog, MilestonePaymentLogCreateDto } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createContract = async (data: ContractCreateDto): Promise<Contract> => {
	const response = await HttpService.post("api/v1/contracts", data, headers, true);
	return response;
};

export const updateContract = async (id: string, data: Partial<ContractCreateDto>): Promise<Contract> => {
	const response = await HttpService.patch(`api/v1/contracts/${id}`, data, headers, true);
	return response;
};

export const getContractById = async (id: string): Promise<Contract> => {
	const response = await HttpService.get(`api/v1/contracts/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getContracts = async (query?: Record<string, string | number | boolean>): Promise<{ data: Contract[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/contracts${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteContract = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/contracts/${id}`, { "x-custom-lang": "en" }, true);
};

export const uploadContractFile = async (file: File): Promise<{ id: string; name: string; size: number; type: string; path: string }> => {
	const formData = new FormData();
	formData.append("file", file);

	const response = await HttpService.post(
		"api/v1/files/upload",
		formData,
		{ "Content-Type": "multipart/form-data" },
		true
	);

	return response;
};

// Milestone Payment Log CRUD Functions
export const createMilestonePaymentLog = async (data: MilestonePaymentLogCreateDto): Promise<MilestonePaymentLog> => {
	const response = await HttpService.post("api/v1/milestone-payment-logs", data, headers, true);
	return response;
};

export const getMilestonePaymentLogs = async (query?: Record<string, string | number | boolean>): Promise<{ data: MilestonePaymentLog[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/milestone-payment-logs${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getMilestonePaymentLogById = async (id: string): Promise<MilestonePaymentLog> => {
	const response = await HttpService.get(`api/v1/milestone-payment-logs/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getMilestonePaymentLogsByMilestone = async (milestoneId: string): Promise<{ data: MilestonePaymentLog[]; totalCount?: number }> => {
	const response = await HttpService.get(`api/v1/milestone-payment-logs/milestone/${milestoneId}`, true, { "x-custom-lang": "en" });
	return response;
};

export const updateMilestonePaymentLog = async (id: string, data: Partial<MilestonePaymentLogCreateDto>): Promise<MilestonePaymentLog> => {
	const response = await HttpService.patch(`api/v1/milestone-payment-logs/${id}`, data, headers, true);
	return response;
};

export const deleteMilestonePaymentLog = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/milestone-payment-logs/${id}`, { "x-custom-lang": "en" }, true);
};

// Emergency Contracts Functions
export const getEmergencyContracts = async (query?: Record<string, string | number | boolean>): Promise<{ data: Contract[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/contracts/emergency${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};


